import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnergieversorger = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_2",
	"data-name": "Ebene 2",
	xmlns: "http://www.w3.org/2000/svg",
	width: 103.373,
	height: 80.521,
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "m52.07,99.52c14.51,0,22.83-9.97,22.83-27.36,0-11.98-7.84-24.1-22.83-24.1s-22.83,12.12-22.83,24.1c0,17.39,8.32,27.36,22.83,27.36Zm0-42.42c9.53,0,13.79,7.56,13.79,15.06,0,4.53,0,18.32-13.79,18.32-3.41,0-13.79,0-13.79-18.32,0-7.49,4.26-15.06,13.79-15.06Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "m190,10c-.58,0-57.88,0-85,0h-5v104.96l-13.56-2.5c-2.46-.78-17.06-5.17-32.98-5.17h-.25c-27.83.08-35.21,7.17-36.41,8.59l-.58.69-.31.85c-.32.88-7.73,21.97-5.25,49.37l.21,2.3,1.87,1.34c3.42,2.46,7.66,5.33,11.75,8.1,6.02,4.08,12.25,8.31,15.71,11.08l6.25-7.85c-3.77-3.03-9.89-7.18-16.36-11.57-3.3-2.24-6.7-4.54-9.64-6.61-1.42-20.36,3.04-36.83,4.46-41.46,2.1-1.29,9.46-4.74,28.34-4.8h.22c8.79,0,17.3,1.53,23.04,2.86l-10.15,69.79h9.14l9.83-67.57,14.68,2.72v24.85h90v-10h-80v-12.99l13.85,2.57,2.17-.58.59-.35c.2-.12,20.35-12.11,33.24-20.08l-5.24-8.56c-10.87,6.72-26.97,16.34-31.72,19.18l-12.88-2.37V20c28.52.06,79.46,0,80,0v-10Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 130,
			y: 40,
			width: 15,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 160,
			y: 40,
			width: 30,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 130,
			y: 60,
			width: 15,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 160,
			y: 60,
			width: 30,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 130,
			y: 80,
			width: 15,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 160,
			y: 80,
			width: 30,
			height: 10
		})
	]
});
export default SvgEnergieversorger;
